import React, { useState } from 'react';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import HousecallThemeProvider from 'housecall-ui/dist/DesignSystem/Styles/HousecallThemeProvider';
import MenuIcon from 'housecall-ui/dist/IconsAndImages/Icons/Menu';
import IconButton from 'housecall-ui/dist/library/Buttons/IconButton';
import { QueryClientProvider } from 'resources/ReactQuery/QueryClientProvider';

import GlobalSearchContainer from 'components/Toolbar/v2/GlobalSearch/GlobalSearchContainer';

import { NavProps } from '../types';

import AddButton from './AddButton';
import AvatarMenu from './AvatarMenu';
import MobileNavMenu from './MobileNavMenu';

const MobileNav = ({ onTabChange, activeTab, tabs = [] }: NavProps) => {
  const [mobileNavMenuOpen, setMobileNavMenuOpen] = useState(false);

  return (
    <Grid data-testid="MobileNav-root" container alignItems="center" spacing={1} wrap="nowrap">
      <Grid item xs="auto" md={6}>
        <IconButton aria-label="Mobile Nav Menu" onClick={() => setMobileNavMenuOpen(true)}>
          <MenuIcon />
        </IconButton>
        <MobileNavMenu
          open={mobileNavMenuOpen}
          activeTab={activeTab}
          onClose={() => setMobileNavMenuOpen(false)}
          onChange={onTabChange}
          tabs={tabs}
        />
      </Grid>
      <Grid container item xs="auto" spacing={1} alignItems="center" justify="flex-end" wrap="nowrap">
        <Grid item>
          <HousecallThemeProvider mode="light">
            <QueryClientProvider>
              <GlobalSearchContainer responsive />
            </QueryClientProvider>
          </HousecallThemeProvider>
        </Grid>
        <Grid item>
          <AddButton variant="icon" />
        </Grid>
        <Grid item>
          <AvatarMenu />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default MobileNav;
